export const styledMarkers: ApexMarkers = {
  size: 0,
  colors: '#fff',
  strokeColors: 'var(--accent-color)',
  strokeWidth: 4,
  hover: {
    size: 8
  }
}
